import { store } from 'app/redux/store';
import { IUser } from 'app/services/user';
import {
  updateKey,
  updateFieldArrayKey,
  TDependentsChildren,
} from '../edit/TaxQuestionnaire/PersonalDetails/TheBasics/Dependents/slice';

export default function autoFillDependentsSlice(user: IUser) {
  const { dependents } = user;

  store.dispatch(updateKey({ key: 'dependentsChildren', value: [] }));

  const toFill: TDependentsChildren = [];
  dependents?.forEach((dependent) => {
    toFill.push({
      firstName: dependent.firstname,
      lastName: dependent.lastname,
      dateOfBirth: dependent.birth_date,
      relationship: dependent.relationship,
      SSN: dependent.ssn,
    });
  });

  store.dispatch(
    updateFieldArrayKey({ key: 'dependentsChildren', value: toFill }),
  );
}
